// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml = require("rescript/lib/js/caml.js");
var Curry = require("rescript/lib/js/curry.js");
var Decco = require("decco/src/Decco.bs.js");
var Belt_Id = require("rescript/lib/js/belt_Id.js");
var Js_json = require("rescript/lib/js/js_json.js");
var Belt_Map = require("rescript/lib/js/belt_Map.js");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var Belt_MapInt = require("rescript/lib/js/belt_MapInt.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Selector$SmartcutsMacros = require("./Selector.bs.js");
var ArrayUtils$SmartcutsMacros = require("../../bs-utils/src/ArrayUtils.bs.js");
var OptionUtils$SmartcutsMacros = require("../../bs-utils/src/OptionUtils.bs.js");
var SmartcutIds$SmartcutsMacros = require("./SmartcutIds.bs.js");
var DOM__Element$SmartcutsMacros = require("./DOM__Element.bs.js");
var LoginScenario$SmartcutsMacros = require("./LoginScenario.bs.js");
var CustomMapBuilders$SmartcutsMacros = require("./CustomMapBuilders.bs.js");
var InterfaceBtwnContentScriptAndBg$SmartcutsMacros = require("./InterfaceBtwnContentScriptAndBg.bs.js");
var InterfaceBtwnRecordingAndPlayback$SmartcutsMacros = require("./InterfaceBtwnRecordingAndPlayback.bs.js");
var UserCredential__PasswordCredential$SmartcutsMacros = require("./UserCredential__PasswordCredential.bs.js");

var DomElementCompare = Belt_Id.MakeComparable({
      cmp: DOM__Element$SmartcutsMacros.compare
    });

function make(param) {
  return Belt_Map.make(DomElementCompare);
}

function fromArray(param) {
  return Belt_Map.fromArray(param, DomElementCompare);
}

var MapDomElement = {
  make: make,
  fromArray: fromArray
};

var t_encode = Selector$SmartcutsMacros.selector_encode;

var t_decode = Selector$SmartcutsMacros.selector_decode;

function cmp(a, b) {
  if (a === b) {
    return 0;
  } else {
    return 1;
  }
}

var MapSelector = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode,
      t_decode: t_decode,
      cmp: cmp
    });

function t_encode$1(v) {
  return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_encode(v);
}

function t_decode$1(v) {
  return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.recordingId_decode(v);
}

function cmp$1(a, b) {
  return Caml.caml_int_compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(a), InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(b));
}

var MapRecordingTabId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$1,
      t_decode: t_decode$1,
      cmp: cmp$1
    });

function t_encode$2(v) {
  return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_encode(v);
}

function t_decode$2(v) {
  return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.recordingId_decode(v);
}

function cmp$2(a, b) {
  return Caml.caml_int_compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(a), InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.WindowId.asInt(b));
}

var MapRecordingWindowId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$2,
      t_decode: t_decode$2,
      cmp: cmp$2
    });

function t_encode$3(v) {
  return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_encode(v);
}

function t_decode$3(v) {
  return InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.playbackId_decode(v);
}

function cmp$3(a, b) {
  return Caml.caml_int_compare(InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(a), InterfaceBtwnRecordingAndPlayback$SmartcutsMacros.TabId.asInt(b));
}

var MapPlaybackTabId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$3,
      t_decode: t_decode$3,
      cmp: cmp$3
    });

var t_encode$4 = SmartcutIds$SmartcutsMacros.smartcutId_encode;

var t_decode$4 = SmartcutIds$SmartcutsMacros.smartcutId_decode;

var cmp$4 = SmartcutIds$SmartcutsMacros.SmartcutId.cmp;

var MapSmartcutId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$4,
      t_decode: t_decode$4,
      cmp: cmp$4
    });

var t_encode$5 = SmartcutIds$SmartcutsMacros.installedSmartcutId_encode;

var t_decode$5 = SmartcutIds$SmartcutsMacros.installedSmartcutId_decode;

var cmp$5 = SmartcutIds$SmartcutsMacros.InstalledSmartcutId.cmp;

var MapInstalledSmartcutId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$5,
      t_decode: t_decode$5,
      cmp: cmp$5
    });

var t_encode$6 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_encode;

var t_decode$6 = SmartcutIds$SmartcutsMacros.recordedSmartcutId_decode;

var cmp$6 = SmartcutIds$SmartcutsMacros.RecordedSmartcutId.cmp;

var MapRecordedSmartcutId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$6,
      t_decode: t_decode$6,
      cmp: cmp$6
    });

function kvPairs_encode(encoder_value, v) {
  return Decco.arrayToJson((function (param) {
                return [
                        Decco.stringToJson(param[0]),
                        Curry._1(encoder_value, param[1])
                      ];
              }), v);
}

function kvPairs_decode(decoder_value, v) {
  return Decco.arrayFromJson((function (json) {
                var match = Js_json.classify(json);
                if (typeof match === "number") {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                if (match.TAG !== /* JSONArray */3) {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                var match$1 = match._0;
                if (match$1.length !== 2) {
                  return Decco.error(undefined, "Incorrect cardinality", json);
                }
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = Decco.stringFromJson(v0);
                var match$3 = Curry._1(decoder_value, v1);
                if (match$2.TAG === /* Ok */0) {
                  if (match$3.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [
                              match$2._0,
                              match$3._0
                            ]
                          };
                  }
                  var e = match$3._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = match$2._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[0]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }), v);
}

function t_encode$7(value_encode, m) {
  return kvPairs_encode(value_encode, Belt_MapString.toArray(m));
}

function t_decode$7(value_decode, encoded) {
  var decodeError = kvPairs_decode(value_decode, encoded);
  if (decodeError.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: Belt_MapString.fromArray(decodeError._0)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: decodeError._0
          };
  }
}

var MapStringWithDeccoSupport = {
  kvPairs_encode: kvPairs_encode,
  kvPairs_decode: kvPairs_decode,
  t_encode: t_encode$7,
  t_decode: t_decode$7
};

function kvPairs_encode$1(encoder_value, v) {
  return Decco.arrayToJson((function (param) {
                return [
                        Decco.intToJson(param[0]),
                        Curry._1(encoder_value, param[1])
                      ];
              }), v);
}

function kvPairs_decode$1(decoder_value, v) {
  return Decco.arrayFromJson((function (json) {
                var match = Js_json.classify(json);
                if (typeof match === "number") {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                if (match.TAG !== /* JSONArray */3) {
                  return Decco.error(undefined, "Not a tuple", json);
                }
                var match$1 = match._0;
                if (match$1.length !== 2) {
                  return Decco.error(undefined, "Incorrect cardinality", json);
                }
                var v0 = match$1[0];
                var v1 = match$1[1];
                var match$2 = Decco.intFromJson(v0);
                var match$3 = Curry._1(decoder_value, v1);
                if (match$2.TAG === /* Ok */0) {
                  if (match$3.TAG === /* Ok */0) {
                    return {
                            TAG: /* Ok */0,
                            _0: [
                              match$2._0,
                              match$3._0
                            ]
                          };
                  }
                  var e = match$3._0;
                  return {
                          TAG: /* Error */1,
                          _0: {
                            path: "[1]" + e.path,
                            message: e.message,
                            value: e.value
                          }
                        };
                }
                var e$1 = match$2._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: "[0]" + e$1.path,
                          message: e$1.message,
                          value: e$1.value
                        }
                      };
              }), v);
}

function t_encode$8(value_encode, m) {
  return kvPairs_encode$1(value_encode, Belt_MapInt.toArray(m));
}

function t_decode$8(value_decode, encoded) {
  var decodeError = kvPairs_decode$1(value_decode, encoded);
  if (decodeError.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: Belt_MapInt.fromArray(decodeError._0)
          };
  } else {
    return {
            TAG: /* Error */1,
            _0: decodeError._0
          };
  }
}

var MapIntWithDeccoSupport = {
  kvPairs_encode: kvPairs_encode$1,
  kvPairs_decode: kvPairs_decode$1,
  t_encode: t_encode$8,
  t_decode: t_decode$8
};

function t_encode$9(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_encode(v);
}

function t_decode$9(v) {
  return InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.t_decode(v);
}

var cmp$7 = InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.cmp;

var include = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$9,
      t_decode: t_decode$9,
      cmp: cmp$7
    });

function stringify(v) {
  return "keys=[" + (Belt_Array.map(Belt_Map.keysToArray(v), InterfaceBtwnContentScriptAndBg$SmartcutsMacros.ContentScriptFailureId.stringify).join(", ") + "];");
}

var MapContentScriptFailureId_KeyCompare = include.KeyCompare;

var MapContentScriptFailureId_make = include.make;

var MapContentScriptFailureId_fromArray = include.fromArray;

var MapContentScriptFailureId_kvPairs_encode = include.kvPairs_encode;

var MapContentScriptFailureId_kvPairs_decode = include.kvPairs_decode;

var MapContentScriptFailureId_t_encode = include.t_encode;

var MapContentScriptFailureId_t_decode = include.t_decode;

var MapContentScriptFailureId = {
  KeyCompare: MapContentScriptFailureId_KeyCompare,
  make: MapContentScriptFailureId_make,
  fromArray: MapContentScriptFailureId_fromArray,
  kvPairs_encode: MapContentScriptFailureId_kvPairs_encode,
  kvPairs_decode: MapContentScriptFailureId_kvPairs_decode,
  t_encode: MapContentScriptFailureId_t_encode,
  t_decode: MapContentScriptFailureId_t_decode,
  stringify: stringify
};

var t_encode$10 = LoginScenario$SmartcutsMacros.t_encode;

var t_decode$10 = LoginScenario$SmartcutsMacros.t_decode;

function cmp$8(s1, s2) {
  return LoginScenario$SmartcutsMacros.indexOf(s1) - LoginScenario$SmartcutsMacros.indexOf(s2) | 0;
}

var include$1 = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$10,
      t_decode: t_decode$10,
      cmp: cmp$8
    });

var fromArray$1 = include$1.fromArray;

function keepMap(v, f) {
  return Curry._1(fromArray$1, Belt_Array.keepMap(Belt_Map.toArray(v), (function (param) {
                    return Curry._2(f, param[0], param[1]);
                  })));
}

var MapLoginScenario_KeyCompare = include$1.KeyCompare;

var MapLoginScenario_make = include$1.make;

var MapLoginScenario_kvPairs_encode = include$1.kvPairs_encode;

var MapLoginScenario_kvPairs_decode = include$1.kvPairs_decode;

var MapLoginScenario_t_encode = include$1.t_encode;

var MapLoginScenario_t_decode = include$1.t_decode;

var MapLoginScenario = {
  KeyCompare: MapLoginScenario_KeyCompare,
  make: MapLoginScenario_make,
  fromArray: fromArray$1,
  kvPairs_encode: MapLoginScenario_kvPairs_encode,
  kvPairs_decode: MapLoginScenario_kvPairs_decode,
  t_encode: MapLoginScenario_t_encode,
  t_decode: MapLoginScenario_t_decode,
  keepMap: keepMap
};

function t_encode$11(v) {
  return Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_encode, v);
}

function t_decode$11(v) {
  return Curry._1(UserCredential__PasswordCredential$SmartcutsMacros.id_decode, v);
}

var cmp$9 = Caml.caml_string_compare;

var MapPasswordCredentialId = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$11,
      t_decode: t_decode$11,
      cmp: cmp$9
    });

function t_encode$12(v) {
  return Decco.arrayToJson(Decco.stringToJson, v);
}

function t_decode$12(v) {
  return Decco.arrayFromJson(Decco.stringFromJson, v);
}

function cmp$10(htmlTagPath1, htmlTagPath2) {
  var longPath = htmlTagPath1.length >= htmlTagPath2.length ? htmlTagPath1 : htmlTagPath2;
  var arg = ArrayUtils$SmartcutsMacros.shortcutWithIndex((function (_item, index) {
          var match = Belt_Array.get(htmlTagPath1, index);
          var match$1 = Belt_Array.get(htmlTagPath2, index);
          if (match === undefined) {
            if (match$1 !== undefined) {
              return -1;
            } else {
              return ;
            }
          }
          if (match$1 === undefined) {
            return 1;
          }
          var result = Caml_obj.caml_compare(Caml_option.valFromOption(match), Caml_option.valFromOption(match$1));
          if (result === 0) {
            return ;
          } else {
            return result;
          }
        }), longPath);
  var param = 0;
  return OptionUtils$SmartcutsMacros.withDefault(param, arg);
}

var MapHtmlTagPath = CustomMapBuilders$SmartcutsMacros.MakeCustomMapWithDeccoSupport({
      t_encode: t_encode$12,
      t_decode: t_decode$12,
      cmp: cmp$10
    });

exports.DomElementCompare = DomElementCompare;
exports.MapDomElement = MapDomElement;
exports.MapSelector = MapSelector;
exports.MapRecordingTabId = MapRecordingTabId;
exports.MapRecordingWindowId = MapRecordingWindowId;
exports.MapPlaybackTabId = MapPlaybackTabId;
exports.MapSmartcutId = MapSmartcutId;
exports.MapInstalledSmartcutId = MapInstalledSmartcutId;
exports.MapRecordedSmartcutId = MapRecordedSmartcutId;
exports.MapStringWithDeccoSupport = MapStringWithDeccoSupport;
exports.MapIntWithDeccoSupport = MapIntWithDeccoSupport;
exports.MapContentScriptFailureId = MapContentScriptFailureId;
exports.MapLoginScenario = MapLoginScenario;
exports.MapPasswordCredentialId = MapPasswordCredentialId;
exports.MapHtmlTagPath = MapHtmlTagPath;
/* DomElementCompare Not a pure module */
